// src/config.js
const AppConfig = {
    title: "Failed loading….",
    paragraph: "Loading failed due to some problems",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "failed",
    id: "7383626"
};

export default AppConfig;